export default {
  any_device: 'любое',
  blocked: 'заблокирована',
  online: 'онлайн',
  offline: 'офлайн'
};
